module.exports = __webpack_public_path__ + "static/media/swamiji-inside-kuti.13de97f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swamiji-inside-kuti.jpeg
// module id = 536
// module chunks = 0